module.exports = __webpack_public_path__ + "static/media/logo_mc_visa.3e41f2a6.png";